import { Link } from 'react-router-dom';

const productList = [
  {
    id: 'cuiguan',
    name: '翠冠梨',
    tagline: '盛夏第一口清甜',
    description: '翠冠梨是惠美梨的明星品种，果实呈圆形或长圆形，果皮黄绿色，果肉洁白细腻，汁多味甜，石细胞极少。每年7月中下旬成熟，是夏季消暑解渴的绝佳选择。',
    features: ['皮薄汁多', '细腻无渣', '清甜爽口', '夏季专属'],
    image: 'https://readdy.ai/api/search-image?query=A%20single%20ripe%20greenish%20golden%20asian%20pear%20with%20smooth%20skin%20on%20a%20minimal%20cream%20background%2C%20soft%20natural%20lighting%2C%20elegant%20food%20photography%2C%20dew%20drops%2C%20clean%20composition%2C%20warm%20natural%20tones%2C%20professional%20product%20photography%2C%20high%20detail&width=600&height=700&seq=cuiguan-pear&orientation=portrait',
  },
  {
    id: 'huanghua',
    name: '黄花梨',
    tagline: '金黄饱满，香甜浓郁',
    description: '黄花梨果实硕大，果皮金黄色，外观极为诱人。果肉酥脆爽口，甜度高、香气浓郁，是梨中佳品。黄花梨成熟期在8月下旬至9月上旬，正值金秋时节，是中秋送礼的上佳之选。',
    features: ['金黄外观', '酥脆口感', '香甜浓郁', '送礼首选'],
    image: 'https://readdy.ai/api/search-image?query=A%20single%20ripe%20golden%20yellow%20asian%20pear%20with%20smooth%20skin%20on%20a%20minimal%20cream%20background%2C%20soft%20natural%20lighting%2C%20elegant%20food%20photography%2C%20warm%20golden%20tones%2C%20clean%20composition%2C%20professional%20product%20photography%2C%20high%20detail&width=600&height=700&seq=huanghua-pear&orientation=portrait',
  },
  {
    id: 'fengshui',
    name: '丰水梨',
    tagline: '汁水丰盈，润泽心田',
    description: '丰水梨果形端正，果皮棕褐色，果肉晶莹剔透、口感极嫩。正如其名，丰水梨的汁水含量在梨果品种中首屈一指，一口咬下，清甜的梨汁瞬间充盈口腔，令人回味无穷。',
    features: ['汁多如泉', '肉质细嫩', '甜而不腻', '营养丰富'],
    image: 'https://readdy.ai/api/search-image?query=A%20single%20ripe%20brown%20skinned%20asian%20pear%20with%20smooth%20texture%20on%20a%20minimal%20cream%20background%2C%20soft%20natural%20lighting%2C%20elegant%20food%20photography%2C%20juicy%20appearance%2C%20clean%20composition%2C%20warm%20earthy%20tones%2C%20professional%20product%20photography&width=600&height=700&seq=fengshui-pear&orientation=portrait',
  },
  {
    id: 'xuehua',
    name: '雪花梨',
    tagline: '洁白如雪，清雅甘甜',
    description: '雪花梨因肉质洁白如雪而得名，果实呈卵圆形，果皮绿黄色。雪花梨口感清雅甘甜，不腻不燥，且耐储存，是惠美梨冬季主推的明星品种。',
    features: ['肉质洁白', '清雅甘甜', '耐储存', '养生佳品'],
    image: 'https://readdy.ai/api/search-image?query=A%20single%20ripe%20pale%20green%20asian%20pear%20with%20smooth%20skin%20on%20a%20minimal%20cream%20background%2C%20soft%20natural%20lighting%2C%20elegant%20food%20photography%2C%20white%20flesh%20visible%2C%20clean%20composition%2C%20fresh%20crisp%20aesthetic%2C%20professional%20product%20photography&width=600&height=700&seq=xuehua-pear&orientation=portrait',
  },
];

export default function ProductShowcase() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            品种系列
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            甄选品种，各有千秋
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            惠美梨精心培育四大梨果品种，覆盖夏秋冬三季，满足不同时节、不同场景的品质梨果需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-product-shop>
          {productList.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="group rounded-2xl bg-background-50 overflow-hidden hover:bg-background-50 transition-colors cursor-pointer"
            >
              <div className="relative h-56 md:h-64 overflow-hidden">
                <img
                  src={category.image}
                  alt={`惠美梨${category.name}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium">
                    {category.tagline}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">
                  {category.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {category.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {category.features.map((f) => (
                    <span
                      key={f}
                      className="px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium"
                    >
                      {f}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-500 text-primary-600 font-medium text-sm hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部品种
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}